<!--充值记录-->
<template>
  <a-card :bordered="false" title="充值记录" class="recharge-record-page">
    <search-page-view
      ref="pageList"
      :col="3"
      :itemNames="searchItemList"
      :buttonItems="['exportButton']"
      :columns="getColumns()"
      :queryParams="queryParams"
      :requestPromise="getRechargeListPromise"
      :showResetButton="true"
      :leftSpace="36"
      row-key="rechargeNo"
      @reset="resetEvent"
    >
      <a-form-item slot="search_submitDate" label="提交日期" v-bind="searchItemLayout">
        <a-range-picker
          :value="selectedSubmitDate"
          format="YYYY-MM-DD"
          style="width: 100%"
          @change="onSubmitDateChange"
        />
      </a-form-item>

      <a-form-item slot="search_status" label="状态" v-bind="searchItemLayout">
        <a-select allowClear style="width: 100%" v-model="queryParams.status" placeholder="请选择">
          <a-select-option v-for="item in statusList" :key="item.code" :value="item.code">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-button slot="exportButton" style="margin-left: 8px" @click="exportData">导出</a-button>

      <template slot="operation">
        <div class="table-operation">
          <a-button type="primary" @click="handleAdd">
            <a-icon type="plus"/>
            新建充值
          </a-button>
        </div>
      </template>

      <template slot="rechargeNo" slot-scope="rowItem">
        <span class="recharge-no">{{ getRechargeNo(rowItem.record) }}</span>
      </template>

      <template slot="submitTime" slot-scope="rowItem">
        {{ getSubmitTime(rowItem.record) }}
      </template>

      <template slot="rechargeAmount" slot-scope="rowItem">
        <span class="amount-text">{{ getAmountText(rowItem.record) }}</span>
      </template>

      <template slot="rechargeVoucher" slot-scope="rowItem">
        <div v-if="getVoucherList(rowItem.record).length" class="voucher-list">
          <a
            v-for="(item, index) in getVisibleVoucherList(rowItem.record)"
            :key="index"
            :href="item"
            target="_blank"
            class="voucher-item"
            :title="isImageFile(item) ? '查看充值凭证' : `查看附件${index + 1}`"
          >
            <img v-if="isImageFile(item)" :src="item" alt="充值凭证" class="voucher-image"/>
            <span v-else class="voucher-file">附件{{ index + 1 }}</span>
          </a>
          <a
            v-if="getHiddenVoucherCount(rowItem.record) > 0"
            :href="getVoucherList(rowItem.record)[0]"
            target="_blank"
            class="voucher-more"
            title="查看更多凭证"
          >
            +{{ getHiddenVoucherCount(rowItem.record) }}
          </a>
        </div>
        <span v-else>-</span>
      </template>

      <template slot="status" slot-scope="rowItem">
        {{ getStatusName(rowItem.record) }}
      </template>

      <template slot="auditRemark" slot-scope="rowItem">
        <span class="audit-remark" :title="getAuditRemark(rowItem.record)">
          {{ getAuditRemark(rowItem.record) }}
        </span>
      </template>
    </search-page-view>

    <new-recharge-request
      :visible.sync="newRechargeVisible"
      :submit-promise="createRechargePromise"
      @success="onRechargeSuccess"
    />
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import NewRechargeRequest from '@/views/finance/components/NewRechargeRequest'

export default {
  name: 'RechargeRecord',
  components: { NewRechargeRequest },
  mixins: [searchForm],
  data() {
    return {
      newRechargeVisible: false,
      selectedSubmitDate: undefined,
      searchItemList: [
        'search_submitDate',
        'search_status'
      ],
      queryParams: {
        merchantId: this.$store.getters.userInfo ? this.$store.getters.userInfo.merchantId : 0,
        rechargeNo: '',
        status: undefined,
        submitDateStart: '',
        submitDateEnd: ''
      },
      statusList: [
        { code: 1, name: '待审核' },
        { code: 2, name: '已通过' },
        { code: 3, name: '已拒绝' }
      ]
    }
  },
  methods: {
    getRechargeListPromise(params) {
      const pageSize = params.limitDto ? params.limitDto.pageSize : 10
      const requestParams = {
        limitDto: {
          pageNum: params.limitDto ? params.limitDto.pageNum : 1,
          pageSize: pageSize
        },
        merchantId: params.merchantId || 0,
        rechargeNo: params.rechargeNo || '',
        status: params.status || 0,
        submitDateStart: params.submitDateStart || '',
        submitDateEnd: params.submitDateEnd || ''
      }

      return this.getHttpServices()
        .getOrderService()
        .post('/platform/v3/recharge/getRechargeList', requestParams)
        .then(res => this.formatListResponse(res, pageSize))
    },
    onSubmitDateChange(dates, dateStrArr) {
      this.selectedSubmitDate = dates
      this.queryParams.submitDateStart = dateStrArr[0] || ''
      this.queryParams.submitDateEnd = dateStrArr[1] || ''
    },
    resetEvent() {
      this.selectedSubmitDate = undefined
      this.queryParams = {
        merchantId: this.$store.getters.userInfo ? this.$store.getters.userInfo.merchantId : 0,
        rechargeNo: '',
        status: undefined,
        submitDateStart: '',
        submitDateEnd: ''
      }
      this.$nextTick(() => {
        this.$refs.pageList.refresh(true)
      })
    },
    exportData() {
      const exportData = {
        merchantId: this.queryParams.merchantId || 0,
        rechargeNo: this.queryParams.rechargeNo || '',
        status: this.queryParams.status || 0,
        submitDateStart: this.queryParams.submitDateStart || '',
        submitDateEnd: this.queryParams.submitDateEnd || ''
      }
      const url = this.getHttpServices().getTargetUrl('/platform/v3/recharge/exportRechargeList', exportData)
      this.getHttpServices().getOrderService().get(url).then(detail => {
        this.$message.success('成功导出')
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.$message.error('导出失败')
      })
    },
    getColumns() {
      return [
        {
          title: '充值ID',
          dataIndex: 'rechargeNo',
          width: 210,
          scopedSlots: { customRender: 'rechargeNo' }
        },
        {
          title: '提交时间',
          dataIndex: 'submitTime',
          width: 180,
          scopedSlots: { customRender: 'submitTime' }
        },
        {
          title: '充值金额',
          dataIndex: 'rechargeAmount',
          width: 120,
          align: 'right',
          scopedSlots: { customRender: 'rechargeAmount' }
        },
        {
          title: '充值凭证',
          dataIndex: 'voucherImg',
          width: 220,
          scopedSlots: { customRender: 'rechargeVoucher' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 120,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '审核备注',
          dataIndex: 'auditRemark',
          width: 180,
          scopedSlots: { customRender: 'auditRemark' }
        }
      ]
    },
    formatListResponse(res, pageSize) {
      if (Array.isArray(res)) {
        return {
          data: res,
          totalCount: res.length,
          pageCount: 1
        }
      }

      res = res || {}
      const pageData = res.data && !Array.isArray(res.data) ? res.data : res
      const data = Array.isArray(pageData.data)
        ? pageData.data
        : Array.isArray(pageData.records)
          ? pageData.records
          : Array.isArray(pageData.list)
            ? pageData.list
            : []
      const totalCount = this.getFirstValid([
        pageData.totalCount,
        pageData.total,
        pageData.count,
        data.length
      ])
      const pageCount = this.getFirstValid([
        pageData.pageCount,
        pageData.totalPage,
        Math.ceil(Number(totalCount || 0) / pageSize)
      ])

      return {
        ...res,
        ...pageData,
        data,
        totalCount,
        pageCount
      }
    },
    getFirstValid(list) {
      const value = list.find(item => item !== undefined && item !== null && item !== '')
      return value === undefined ? '' : value
    },
    getRechargeNo(record = {}) {
      return this.getFirstValid([record.rechargeNo, record.rechargeId, record.id, '-'])
    },
    getSubmitTime(record = {}) {
      return this.getFirstValid([record.submitTime, record.submitDate, record.createTime, record.createDt, '-'])
    },
    getAmountText(record = {}) {
      const amount = this.getFirstValid([record.rechargeAmount, record.amount, record.rechargeMoney, 0])
      const numberAmount = Number(amount)
      return isNaN(numberAmount) ? `￥${amount}` : `￥${numberAmount.toFixed(2)}`
    },
    getVoucherList(record = {}) {
      const value = this.getFirstValid([
        record.voucherImg,
        record.rechargeVoucher,
        record.voucherUrl,
        record.voucher,
        record.invoiceVoucher,
        record.url
      ])
      if (Array.isArray(value)) {
        return value.filter(Boolean)
      }
      if (typeof value === 'string') {
        return value.split(',').map(item => item.trim()).filter(Boolean)
      }
      return []
    },
    getVisibleVoucherList(record = {}) {
      return this.getVoucherList(record).slice(0, 3)
    },
    getHiddenVoucherCount(record = {}) {
      const count = this.getVoucherList(record).length - this.getVisibleVoucherList(record).length
      return count > 0 ? count : 0
    },
    isImageFile(url) {
      const path = String(url || '').split('?')[0].toLowerCase()
      if (/\.(pdf|docx?|xlsx?|zip|rar)$/.test(path)) {
        return false
      }
      return /\.(png|jpe?g|gif|webp|bmp|heic|heif)$/.test(path) || /^https?:\/\//.test(path)
    },
    getStatusName(record = {}) {
      if (record.statusName) {
        return record.statusName
      }
      const item = this.statusList.find(item => item.code === Number(record.status))
      return item ? item.name : '-'
    },
    getAuditRemark(record = {}) {
      return this.getFirstValid([record.auditRemark, record.remark, record.auditDesc, '-'])
    },
    handleAdd() {
      this.newRechargeVisible = true
    },
    createRechargePromise(params) {
      const requestParams = {
        amount: Number(params.amount),
        voucherImg: params.voucherImg || ''
      }
      return this.getHttpServices()
        .getOrderService()
        .post('/platform/v3/recharge/createRecharge', requestParams)
    },
    onRechargeSuccess() {
      this.$refs.pageList.refresh(true)
    }
  }
}
</script>

<style scoped lang="less">
.recharge-record-page {
  width: 100%;

  /deep/ .ant-card-body {
    padding: 24px 32px;
  }

  /deep/ .ant-table-thead > tr > th {
    font-weight: 600;
    color: #111;
    background: #fafafa;
  }

  /deep/ .ant-table table {
    table-layout: fixed;
  }

  /deep/ .ant-table-tbody > tr > td {
    padding: 14px 16px;
    vertical-align: middle;
  }

  .table-operation {
    margin: 18px 0 24px;
  }

  .amount-text {
    color: #333;
    font-weight: 500;
    white-space: nowrap;
  }

  .recharge-no {
    display: inline-block;
    max-width: 180px;
    color: #243041;
    word-break: break-all;
  }

  .audit-remark {
    display: inline-block;
    max-width: 160px;
    overflow: hidden;
    color: #333;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .voucher-list {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 6px;
  }

  .voucher-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    overflow: hidden;
    color: #fa8c16;
    font-size: 12px;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
  }

  .voucher-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .voucher-file {
    padding: 0 4px;
    line-height: 18px;
    text-align: center;
  }

  .voucher-more {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    color: #666;
    font-size: 13px;
    background: #f5f5f5;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
  }
}
</style>
